<template>
  <Layout :contained="false">
    <nuxt />

    <!-- Hide the default footer -->
    <span slot="footer"></span>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout'

export default {
  components: { Layout },
}
</script>
